<style>
.beijing{
    background-color: rgb(233, 249, 249);
}
.wodeyuyue{
    font-size: 17px !important;
    color: #009093;
}
.tubiao {
    width: 6px !important;
    height: 6px !important;
}
.xinzeng{
    margin-left: 435px;
    background-color: #009093;
    border-radius: 8px;
    font-size: 17px;
    padding: 1px 15px;
}
.yuyue_bottom{
    display: flex;
    justify-content: space-around;
    border-bottom: 1px solid gray;
}
.border_color{
    border-bottom: 1px solid gray;
}
#yingyeting .el-form-item__label{
  width: 110px !important;
}
.jianwidth{
  width: 300px !important;
}
</style>
<template>
  <div id="yingyeting">
    <div class="banner-business-menu"></div>
    <div data-v-249f9abc="" class="wrapper clearfix">
      <div data-v-249f9abc="" class="content clearfix">
        <div class="main">
          <div>
            <h1>
              营业厅预约服务
            </h1>
            <div>
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="用户类型" prop="resource">
                  <el-radio-group v-model="ruleForm.resource">
                    <el-radio label="个人"></el-radio>
                    <el-radio label="企业"></el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="预约办理业务" prop="region1" class="jiakuan">
                  <el-select v-model="ruleForm.region1" placeholder="请选择预约业务">
                    <el-option label="供排水报装" value="供排水报装"></el-option>
                    <el-option label="过户" value="过户"></el-option>
                    <el-option label="水表迁移" value="水表迁移"></el-option>
                    <el-option label="费用减免" value="费用减免"></el-option>
                    <el-option label="报停用水" value="报停用水"></el-option>
                    <el-option label="恢复用水" value="恢复用水"></el-option>
                    <el-option label="更改托收银行账号" value="更改托收银行账号"></el-option>
                    <el-option label="抄表到户" value="抄表到户"></el-option>
                    <el-option label="供排水管线迁移" value="供排水管线迁移"></el-option>
                    <el-option label="水表口径变更" value="水表口径变更"></el-option>
                    <el-option label="核调用水" value="核调用水"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="行政区域" prop="region2" class="jiakuan">
                  <el-select v-model="ruleForm.region2" placeholder="请选择区域">
                    <el-option label="东区" value="东区"></el-option>
                    <el-option label="西区" value="西区"></el-option>
                    <el-option label="南区" value="南区"></el-option>
                    <el-option label="北区" value="北区"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预约营业厅" prop="region3" class="jiakuan">
                  <el-select v-model="ruleForm.region3" placeholder="请选择营业厅">
                    <el-option label="衡东县第一营业厅" value="1"></el-option>
                    <el-option label="衡东县第二营业厅" value="2"></el-option>
                    <el-option label="衡东县第三营业厅" value="1"></el-option>
                    <el-option label="衡东县第四营业厅" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预约时间" prop="time" class="jiakuan">
                    <el-date-picker
                    v-model="value1"
                    type="datetime"
                    placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="联系人" prop="name">
                    <el-input v-model="ruleForm.name" class="jianwidth"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="num">
                    <el-input v-model="ruleForm.num" class="jianwidth"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" :plain="true" @click="submitForm('ruleForm')">提交</el-button>
                  <!-- <el-button type="primary" @click="submitForm('ruleForm')">提交预约</el-button> -->
                </el-form-item>
              </el-form>
              <!---->
            </div>
          </div>
        </div>
        
        
        <businessAside />
      </div>
    </div>
  </div>
</template>

<script>
import http from '../http/index'
import businessAside from '../components/aside'
export default {
  data() {
    return {
      value1:'',
      ruleForm: {
          name: '',
          num:'',
          region1: '',
          region2: '',
          region3: '',
          value:'',
          resource: '',
        },
        rules: {
          name: [
            { required: true, message: '请输入联系人姓名', trigger: 'blur' },
            { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
          num: [
            { required: true, message: '请输入手机号码', trigger: 'blur' },
            { min: 11, max: 11, message: '11位字符', trigger: 'blur' }
          ],
          region1: [
            { required: true, message: '请选择预约业务', trigger: 'change' }
          ],
          region2: [
            { required: true, message: '请选择行政区域', trigger: 'change' }
          ],
          region3: [
            { required: true, message: '请选择营业厅', trigger: 'change' }
          ],
          // value1: [
          //   { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
          // ],
          resource: [
            { required: true, message: '请选择用户类型', trigger: 'change' }
          ],
        },
      year:'',
      userCode: '',
      step: 0,
      paymentMethod: '',
      eusercod:'',
      sdnijd:{}
    }
  },
  watch: {
    userCode(v) {
      console.log(v, v.length)
    },
  },
  computed:{
    years(){
      return this.year.substring(0,4)
    },
    mounth(){
      return this.year.substring(5,7)
    }
  },
  mounted() {
    console.log(this.years)
  },
  methods: {
    submitForm(){
      this.$message({
          message: '提交成功,请勿重复此操作!',
          type: 'success'
        });
    },
    // submitForm(formName) {
    //     this.$refs[formName].validate((valid) => {
    //       if (valid) {
    //         alert('预约成功!');
    //       } else {
    //         console.log('error submit!!');
    //         return false;
    //       }
    //     });
    //   },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    async goPaymoney(id) {
      try {
        const res = await http.goPaymoney(id);
        this.eusercod=res[0].customercode;
        this.sdnijd=res[0];
        this.year=res[0].billmonth;
        console.log(this.years)
      } catch (ex) {
        console.log(ex);
      }
    },
    onSearchClick(){
      this.goPaymoney(this.userCode);
      this.step=1;
    },
    next() {
      if (this.step < 2) {
        this.step++
      }
    },
  },
  components: {
    businessAside,
  },
}
</script>

<style>
</style>